"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCrossellModuleData = void 0;
const crossellModule_1 = require("../../domain/crossellModule");
// Utils
const mapImages_utility_1 = require("../../../utils/mapImages.utility");
const trackingActions = __importStar(require("../../tracking/actions"));
const mapCrossellModuleData = (propositions, tracker, crossellConfig) => propositions?.map((proposition) => {
    const { content, feedback, locationId } = proposition;
    const { creativityId, type, title, description, images, linkUrl } = content;
    const onClickTextLink = () => {
        crossellConfig?.onClickTextLink?.();
        tracker?.track(trackingActions.CROSSELL_MODULE_OPEN, { item: proposition, index: propositions.indexOf(proposition), title });
    };
    return {
        creativityId,
        description,
        feedback,
        image: (0, mapImages_utility_1.mapImages)(images),
        linkUrl,
        linkAction: crossellConfig?.linkAction ?? crossellModule_1.LinkActionType.NAVIGATION,
        linkContent: 'mbCrossellModule.navigationLink',
        linkIcon: crossellConfig?.linkIcon ?? crossellModule_1.CrossellLinkIconType.CHEVRON_RIGHT,
        linkVariant: crossellConfig?.linkVariant ?? crossellModule_1.LinkVariantType.PRIMARY,
        linkOnclick: () => null,
        locationId,
        onClickTextLink,
        title,
        type,
    };
});
exports.mapCrossellModuleData = mapCrossellModuleData;
//# sourceMappingURL=mapper.js.map